import { graphql } from "react-relay";

export const QUERY = graphql`
	query searchableAccountTable_Query {
		...searchableAccountTable_QueryFragment
	}
`;

export const QUERY_FRAGMENT = graphql`
	fragment searchableAccountTable_QueryFragment on Query
	@refetchable(queryName: "searchableAccountTable_QueryRefetch")
	@argumentDefinitions(
		first: { type: "Int", defaultValue: 20 }
		after: { type: "String", defaultValue: null }
		nameOpt: { type: "String", defaultValue: null }
	) {
		Admin {
			Auth {
				SelectAccounts(first: $first, after: $after, nameOpt: $nameOpt, ids: [])
					@connection(key: "searchableAccountTable_SelectAccounts") {
					edges {
						node {
							...searchableAccountTable_AccountFragment
						}
					}
				}
			}
		}
	}
`;

export const ACCOUNT_FRAGMENT = graphql`
	fragment searchableAccountTable_AccountFragment on Account @inline {
		id
		name
		extension(accountExtensionKind: Tka) {
			... on TkaAccountExtension {
				users(first: 20) {
					edges {
						node {
							user {
								email
							}
							groups {
								permissions
							}
						}
					}
				}
			}
		}
	}
`;
